export const pretty = (str) => (str.charAt(0).toUpperCase() + str.slice(1)).replace('_', ' ')
